<div class="tw-secret-reveal">
  <p class="tw-secret-reveal__notice">
    This is the only time this {{ subject() }} is shown. Copy it now and store it somewhere safe
    &mdash; it cannot be displayed again.
  </p>
  <div class="tw-secret-reveal__row">
    <code class="tw-secret-reveal__value" data-testid="secret-value">{{ revealedSecret() }}</code>
    <tw-btn
      variant="secondary"
      size="sm"
      type="button"
      [ariaLabel]="'Copy ' + subject() + ' to clipboard'"
      (click)="copy()">
      @if (copied()) {
        Copied
      } @else {
        Copy
      }
    </tw-btn>
  </div>
</div>
